export default __webpack_public_path__ + "static/2_24-9c27268221815b6244116d00fd3e194c.png";